








































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { RoleId } from '@/enum'
import { Game } from '@/class/game'
import VoteViewer from './VoteViewer.vue'
import SelfProclaimButton from './selfProclaim/SelfProclaimButton.vue'
import SelfProclaimModal from './selfProclaim/SelfProclaimModal.vue'
import SelfProclaimNoticeButton from './selfProclaim/SelfProclaimNoticeButton.vue'
import SelfProclaimNoticeModal from './selfProclaim/SelfProclaimNoticeModal.vue'
import ProclaimPoliceArea from './ProclaimPoliceArea.vue'
import ProclaimInvestigatorArea from './ProclaimInvestigatorArea.vue'
import { PlayerListComponentInterface } from './PlayerList/PlayerList.vue'
import PlayerList from './playerList/PlayerList.vue'
import Checkbox from '@/components/Utils/form/checkbox/Checkbox.vue'
import Textarea from '@/components/Utils/form/textarea/Textarea.vue'
import { GamePlayer } from '@/class/gamePlayer'

export enum SelectMode {
  default = 1,
  proclaimIsMafia,
  proclaimIsNotMafia,
  proclaimHasWeapon,
  proclaimHasNotWeapon,
}

@Component({
  components: {
    VoteViewer,
    SelfProclaimButton,
    SelfProclaimModal,
    SelfProclaimNoticeButton,
    SelfProclaimNoticeModal,
    ProclaimPoliceArea,
    ProclaimInvestigatorArea,
    PlayerList,
    Checkbox,
    Textarea,
  }
})
export default class Play extends Vue {
  @Prop() game!: Game;
  @Prop() playerSelf?: GamePlayer;
  @Prop() isGallary!: boolean;

  showsProclaimRoleList = false;
  showsProclaimNoticeRoleList = false;
  selectMode = SelectMode.default
  isFullopen = this.isGallary || false;

  created () {
    this.$watch('gameState', () => {
      this.selectMode = SelectMode.default
    })
  }

  get gameState() {
    return this.game.gameState
  }

  get liveCount () {
    return this.game.players.filter(player => !player.isDead).length
  }

  get canGallaryFullopen () {
    if (!this.game.canGallaryFullopen) {
      this.isFullopen = false
    }

    if (!this.playerSelf) {
      return this.game.canGallaryFullopen
    }

    if (this.playerSelf.isDead && !this.playerSelf.takeOther) {
      return this.game.canGallaryFullopen
    }

    return false
  }

  get playerListData(): PlayerListComponentInterface {
    return {
      game: this.game,
      playerSelf: this.playerSelf,
      inSelectTime: this.inSelectTime,
      inVoteTime: this.inVoteTime,
      isGallary: this.isGallary,
      isFullopen: this.isFullopen,
      onClickPlayer: this.onClickPlayer
    }
  }
  
  showProclaimRoleList() {
    this.showsProclaimRoleList = true
  }

  closeProclaimRoleList() {
    this.showsProclaimRoleList = false
  }

  showProclaimNoticeRoleList() {
    this.showsProclaimNoticeRoleList = true
  }

  closeProclaimNoticeRoleList() {
    this.showsProclaimNoticeRoleList = false
  }

  get showsProclaimArea() {
    if (!this.playerSelf) return false

    if (this.playerSelf.isDead) return false

    if (!this.game.isDay) return false

    return true
  }

  get showsProclaimPoliceArea() {
    return this.showsProclaimArea && this.playerSelf?.selfAppointedRoleId === RoleId.police
  }

  get showsProclaimInvestigatorArea() {
    return this.showsProclaimArea && this.playerSelf?.selfAppointedRoleId === RoleId.investigator
  }

  get isDefaultSelectMode() {
    return this.selectMode === SelectMode.default
  }

  changeSelectMode(mode: SelectMode) {
    this.selectMode = mode
  }

  onClickPlayer(player: GamePlayer) {
    if (this.isGallary) return

    if (!this.playerSelf) return

    if (this.playerSelf.turnEnd) return

    if (this.playerSelf.id === player.id) return

    if (this.selectMode === SelectMode.default) {
      this.selectPlayer(player)
    }

    if (this.selectMode === SelectMode.proclaimIsMafia) {
      this.game.proclaimPoliceResult(this.playerSelf.id, player.id, true)
    }

    if (this.selectMode === SelectMode.proclaimIsNotMafia) {
      this.game.proclaimPoliceResult(this.playerSelf.id, player.id, false)
    }

    if (this.selectMode === SelectMode.proclaimHasWeapon) {
      this.game.proclaimInvestigatorResult(this.playerSelf.id, player.id, true)
    }

    if (this.selectMode === SelectMode.proclaimHasNotWeapon) {
      this.game.proclaimInvestigatorResult(this.playerSelf.id, player.id, false)
    }

    this.selectMode = SelectMode.default
  }

  selectPlayer(player: GamePlayer) {
    if (this.inSelectTime) {
      this.selectTarget(player)
    }

    if (this.inVoteTime) {
      this.vote(player)
    }
  }

  get inSelectTime() {
    if (!this.playerSelf) {
      return false
    }

    if (this.game.isFirstNight && this.playerSelf.role.activeIn.firstNight) {
      return true
    }

    if (this.game.isNight) {
      return this.playerSelf.canNightSelect
    }

    if (this.game.isTakeOther) {
      if (this.playerSelf.takeOther) {
        return true
      }
    }

    return false
  }

  get inVoteTime() {
    if (!this.playerSelf) {
      return false
    }

    if (this.playerSelf.isDead) {
      return false
    }

    if (this.game.isDay && this.game.dayVote) {
      return true
    }

    if (this.game.isVoteStart || this.game.isFinalVoteStart) {
      return true
    }

    if (this.game.isFirstNight || this.game.isNight) {
      return !this.inSelectTime
    }

    return false
  }

  selectTarget(player: GamePlayer) {
    if (!this.playerSelf) return

    if (player.isDead) return

    if (
      this.playerSelf.roleId === RoleId.doctor ||
      this.playerSelf.roleId === RoleId.dancer ||
      this.playerSelf.roleId === RoleId.prostitute) 
    {
      if (this.playerSelf.lastNightSelectedPlayerId === player.id) {
        return
      }
    }

    this.playerSelf.selectedPlayerId = this.playerSelf.selectedPlayerId !== player.id
      ? player.id
      : ""

    this.playerSelf.updateSelectedPlayerId()
  }

  vote(player: GamePlayer) {
    if (!this.playerSelf) return

    if (player.isDead) return

    if (
      this.game.isFinalVoteStart &&
      !this.game.roomFinalVotePlayerIds.some(id => id === player.id)
    ) return

    this.playerSelf.votedPlayerId = this.playerSelf.votedPlayerId !== player.id
      ? player.id
      : ""

    this.playerSelf.updateVotedPlayerId()
  }
}
